import { Box, Typography, TextField } from '@mui/material';
import React from 'react';
import useStore from '../../Store/Store';
import SignUpOnboardingStep from './SignUpOnboardingStep';
import Logo from '../../images/logo.png';
import { RELATIONS } from '../../constants';
import inputValidationService from '../../input-validation.service';
import { ArrowDropDown as CaretDown } from '@mui/icons-material';
import { Avatar, FormControl, MenuItem, Select } from '@mui/material';
import { isEmpty } from 'lodash';
import Button from '../../components/Button';

const InviteCareTeam = ({ handleBackStep, handleNextStep, handleSkipStep, loader }) => {
  const width = useStore((state) => state.screenWidth);
  const [input, setInput] = React.useState('');
  const [error, setError] = React.useState('');
  const [emails, setEmails] = React.useState([]);

  const handleSetInput = (e) => {
    if (e.key === 'Enter') {
      if (isEmpty(input.trim())) {
        return setError('Input cannot be empty!');
      }

      if (!inputValidationService.email(input) && !inputValidationService.validatePhoneNumber(input)) {
        return setError('Enter a valid email or phone number!');
      }
      setError('');

      let userEmail = '';
      let phoneNo = '';

      if (inputValidationService.email(input)) {
        userEmail = input;
      }
      if (inputValidationService.validatePhoneNumber(input)) {
        phoneNo = input;
      }

      setInput('');

      let isExists = false;

      emails.forEach(({ email, phoneNo }) => {
        if (input === email || input === phoneNo) {
          isExists = true;
        }
      });

      if (isExists) {
        return setError('Input is already in the list!');
      }

      setEmails((prev) => {
        return [
          ...prev,
          {
            email: userEmail,
            phoneNo: phoneNo,
            relation: '',
          },
        ];
      });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '50%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '5rem' }}>
        <SignUpOnboardingStep step={3} total={4} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'medium', color: 'rgba(29, 29, 31, 1)' }}>
            Invite your Care team
          </Typography>
        </Box>

        <TextField
          fullWidth
          placeholder="Invite members via email or phone, enter to add"
          variant="outlined"
          sx={{
            borderColor: 'rgba(229, 229, 234, 1)',
            marginBlock: '20px',
          }}
          InputProps={{ style: { borderRadius: '100px' } }}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleSetInput}
          value={input}
        />

        {!isEmpty(error) && <span style={{ color: 'red' }}>{error}</span>}

        {emails.map((item, idx) => (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: '10px' }} key={idx}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                p: 2,
                bgcolor: 'rgba(245, 245, 247, 1)',
                borderRadius: '22px',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                <Avatar src="image.png" sx={{ width: 40, height: 40 }} />
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '16px',
                    fontWeight: '500',
                    color: 'rgba(29, 29, 31, 1)',
                  }}
                >
                  {item?.email || item?.phoneNo}
                </Typography>
              </Box>
              <FormControl variant="outlined" sx={{ minWidth: 240, background: '#fff', border: 'none' }}>
                <Select
                  IconComponent={CaretDown}
                  onChange={(e) =>
                    setEmails((prev) => {
                      let newData = prev;
                      newData[idx].relation = e.target.value;
                      return newData;
                    })
                  }
                >
                  {RELATIONS.map((relation) => (
                    <MenuItem value={relation}>{relation}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        ))}

        <Box sx={{ display: 'flex', gap: 6, marginTop: '40px' }}>
          <Button bg="light" text="Back" onClick={handleBackStep} fullWidth />
          <Button bg="light" text="Skip" onClick={handleSkipStep} fullWidth />
          <Button text="Invite" onClick={() => handleNextStep(emails)} loading={loader} fullWidth />
        </Box>
      </div>
    </Box>
  );
};
export default InviteCareTeam;
